import {
    LayoutDashboard,
    GitBranch,
    Wallet,
    LockOpen,
    PinIcon,
    Vault,
    Banknote
} from 'lucide-react';

// import pages
import Register from '../pages/Register';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Home from '../pages/Home';
import BinaryTree from '../pages/BinaryTree';
import PinList from '../pages/PinList';
import WithdrawList from '../pages/WithdrawList';
import BonusHistory from '../pages/BonusHistory';
import BankDetails from '../pages/BankDetails';
import Contact from '../pages/Contact';
import About from '../pages/About';
import Plan from '../pages/Plan';
import Terms from '../pages/Terms';
import ChangePassword from '../pages/ChangePassword';
import NotFound from '../pages/NotFound';

const routers = [
    /* AUTH ROUTE */
    {
        path: "/register",
        name: "Login",
        component: Register,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'auth'
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'auth'
    },
    /* PUBLIC ROUTE */
    {
        path: "/",
        name: "Home",
        component: Home,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'public'
    },
    {
        path: "/contact-us",
        name: "Contact Us",
        component: Contact,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'public'
    },
    {
        path: "/about-us",
        name: "About Us",
        component: About,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'public'
    },
    {
        path: "/plan",
        name: "Plan",
        component: Plan,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'public'
    },
    {
        path: "/terms-condition",
        name: "terms&condition",
        component: Terms,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'public'
    },
    {
        path: "*",
        name: "Not Found",
        component: NotFound,
        isSideMenu: false,
        isSideLabel: false,
        icon: null,
        type: 'public'
    },
    /* PRIVATE ROUTE */
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        isSideMenu: true,
        isSideLabel: true,
        icon: LayoutDashboard,
        type: 'private'
    },
    {
        path: "/pin-list",
        name: "Pin List",
        component: PinList,
        isSideMenu: true,
        isSideLabel: true,
        icon: PinIcon,
        type: 'private'
    },
    {
        path: "/binary-tree",
        name: "Binary Tree",
        component: BinaryTree,
        isSideMenu: true,
        isSideLabel: true,
        icon: GitBranch,
        type: 'private'
    },
    {
        path: "/bonus-history",
        name: "Bonus History",
        component: BonusHistory,
        isSideMenu: true,
        isSideLabel: true,
        icon: Vault,
        type: 'private'
    },
    {
        path: "/bank-details",
        name: "Bank Details",
        component: BankDetails,
        isSideMenu: true,
        isSideLabel: true,
        icon: Banknote,
        type: 'private'
    },
    {
        path: "/withdraw",
        name: "Withdraw List",
        component: WithdrawList,
        isSideMenu: true,
        isSideLabel: true,
        icon: Wallet,
        type: 'private'
    },
    {
        path: "/change-password",
        name: "Change Password",
        component: ChangePassword,
        isSideMenu: true,
        isSideLabel: true,
        icon: LockOpen,
        type: 'private'
    },
];

export default routers;